export default __webpack_public_path__ + "static/media/multicure-graphic.80f1143b.svg";